export const GLOBAL_SERVICE_NAME = '_global';
export const API_READY_EVENT_NAME = '_apiReady';
export const EMIT_TIMEOUT = 2000;
